<div class="gutter">

	<header #header class="flx-col flx-gap-default">
		<h1 #headerTitle *ngIf="pageTitle">{{ pageTitle }}</h1>
		<div *ngIf="pageContent">
			<app-ve [content]="pageContent"></app-ve>
		</div>
	</header>

	<div class="flx-row flx-wrap-grid flx-wrap-grid-2-sm gutter-v-half">
		<div *ngFor="let collection of collections">
			<div class="collection horizontal-wrap">
				<a class="collection-photo" [routerLink]="['/'+path_offer]" [queryParams]="{collection: collection.path}">
					<app-image [natural]="false" *ngIf="collection.photos?.items.length > 0" [url]="cdn+'/collections/'+collection.photos_directory+'/medium_'+collection.photos.items[0].filename"></app-image>
				</a>
				<div class="collection-info flx-col flx-btwn-strt">
					<h2><a [routerLink]="['/'+path_offer]" [queryParams]="{collection: collection.path}">{{ collection.name }}</a></h2>
					<div>
						<p class="label">{{ collection.total }} {{ convertWord(collection.total) }} <span i18n>ceny już od</span></p>
						<p class="price">{{ collection.min_price | currency }}</p>
						<a class="flat-button primary fat" [routerLink]="['/'+path_offer]" [queryParams]="{collection: collection.path}" i18n>zobacz produkty kolekcji</a>
					</div>
				</div>
			</div>
		</div>
	</div>

</div>